import _ from 'lodash';
import React from 'react';
import { CircularProgress } from '@mui/material';

export default function ComponentLoader({ style, ...props }) {
  const message = _.has(props, 'message') ? props.message : 'Loading Component';

  return (
    <div
      style={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
    >
      <div
        style={{
          gap: '.7rem',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <CircularProgress style={{ opacity: 0.6 }} size={30} color="inherit" />
        {message}
      </div>
    </div>
  );
}
